import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import httpService from "../../../../services/httpServices/httpServices";
import ComponentReport from "../ComponentReport";
import Sidebar from "../../../partials/aside/Sidebar";
import { Link } from "react-router-dom";

function ReportCampaignUser() {
  const params = useParams();
  const userID = params.id;
  const history = useHistory();

  const initObjectInfoUser = {
    firstname: "",
    lastname: "",
    category: "",
    phone: "",
    national_code: "",
    identity_number: "",
    state: "",
    city: "",
    town: "",
    postal_code: "",
    description: "",
  };

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [userInfo, setUserInfo] = useState(initObjectInfoUser);
  const [componentReport, setComponentReport] = useState(<></>);

  useEffect(() => {
    setTokenUserInLocalStorage();
    getUserInfoUseEffect();
  }, []);

  const getUserInfoUseEffect = async () => {
    let userInfo = await getInitInfoUser();
    userInfo = userInfo.data.data;
    setUserInfo(userInfo);
    setComponentReport(<ComponentReport />);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getInitInfoUser = async () => {
    let usersInfo;

    const headersRequest = getHeaderForRequest();
    try {
      usersInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/info-user/" + userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return usersInfo;
  };

  const setTokenUserInLocalStorage = async () => {
    let token = await sendRequestGetTokenUser(userID);
    if (!token) {
      return;
    }

    localStorage.removeItem("token");
    localStorage.setItem("token", token);
  };

  const sendRequestGetTokenUser = async (userID) => {
    let token;
    let headersRequest = getHeaderForRequest();
    try {
      token = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/enter-users-profile/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return token.data.data;
  };

  const returnPageLast = () => {
    localStorage.removeItem("token");
    localStorage.setItem("token", token);
    history.push("/user/all");
  };

  return (
    <>
      <Sidebar activeItem="report-campaigns" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">گزارش کمپین ها</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content" id="report-content">
          <div className="card">
            <div className="card-body px-1">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-2">
                    <div className="d-flex justify-content-between ">
                      <div className="alert alert-danger m-0">
                        <span className="pl-2">
                          <i className="fa fa-exclamation-triangle	"></i>
                        </span>
                        <span>برای بازگشت حتما دکمه روبرو را فشار دهید </span>
                      </div>
                      <div>
                        <Link
                          onClick={returnPageLast}
                          className="btn btn-warning"
                          to={`/user/all`}
                        >
                          <span class="pl-2">بازگشت</span>
                          <span>
                            <i class="fa fa-arrow-left"></i>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-2 px-2">
                    <div className="table-resposive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <td>شماره کاربری</td>
                            <td>نام</td>
                            <td>نام خانوادگی</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{userID}</td>
                            <td>{userInfo.firstname}</td>
                            <td>{userInfo.lastname}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {componentReport}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ReportCampaignUser;
